import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Loader from "@ui/components/loader/Loader";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./font.css";
import AppRoutes from "./ui/layout/route";
import i18n from "./i18n";
import moment from "moment";
function App() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);
    useEffect(() => {
        const preventDefault = (e) => {
            e.preventDefault();
        };
        document.addEventListener("gesturestart", preventDefault, {
            passive: false,
        });
        document.addEventListener("gesturechange", preventDefault, { passive: false });
        document.addEventListener("gestureend", preventDefault, {
            passive: false,
        });
        return () => {
            document.removeEventListener("gesturestart", preventDefault);
            document.removeEventListener("gesturechange", preventDefault);
            document.removeEventListener("gestureend", preventDefault);
        };
    }, []);
    useEffect(() => {
        moment.locale(i18n.language);
    }, [i18n.language]);
    return (_jsx(React.Fragment, { children: _jsxs("div", { className: "site-wrapper", children: [_jsx(AppRoutes, {}), _jsx(Loader, {}), _jsx(ToastContainer, { position: "top-right", autoClose: 5000, hideProgressBar: false, newestOnTop: false, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, draggable: true, pauseOnHover: true, theme: "dark" })] }) }));
}
export default App;
